/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

// LanguageSwitcher.js
import React from 'react';
import './LanguageSwitcher.css';

export default function LanguageSwitcher({ currentLang, onSwitch }) {
  const nextLang = currentLang === 'fr' ? 'en' : 'fr';
  const isMobile = window.innerWidth < 693;
const label = nextLang === 'fr'
  ? (isMobile ? '🇫🇷 FR' : '🇫🇷 Français')
  : (isMobile ? '🇬🇧 EN' : '🇬🇧 English');
  

  return (
    <div className="lang-switcher">
      <button className="lang-btn center" onClick={() => onSwitch(nextLang)}>
        {label}
      </button>
    </div>
  );
}
